module.exports = __webpack_public_path__ + "static/media/DSC01465.b18f4b19.jpg";